// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tkYT","rootMobile":"styles_rootMobile__35QBE"};